import { Link } from 'react-router-dom'

import { Header, OnboardingButton, Subheader } from './common'
import OnboardingFooterNav from './OnboardingFooterNav'

import Section from 'components/common/Section'
import InstallBanner from 'components/dashboard/notification-banners/InstallBanner'
import theme from 'theme'

export const InstallSubheader = props => (
  <Subheader data-testid="dashboard-install-banner-header" {...props}>
    <span css={{ color: theme.colors.green[0] }}>
      Start testing your infrastructure
    </span>{' '}
    against common failures and reduce your incident count.
  </Subheader>
)

const Install = () => {
  return (
    <Section darkTheme>
      <header css={{ marginBottom: theme.space[5] }}>
        <Header css={{ marginBottom: theme.space[4] }}>
          Install Gremlin to begin
        </Header>
        <InstallSubheader />
      </header>
      <main>
        <InstallBanner
          canClose={false}
          css={{
            padding: 0,
            borderRadius: 0,
            background: 'transparent',
            boxShadow: 'none'
          }}
          subTitle={null}
          title={null}
        />
      </main>
      <OnboardingFooterNav previousLink="/onboarding/survey">
        <OnboardingButton as={Link} to="/dashboard">
          Finish
        </OnboardingButton>
      </OnboardingFooterNav>
    </Section>
  )
}

export default Install
